import { ApiReturn } from "components/ForgottenPassword/forgottenPasswordApi";
import { endpoints } from "config";
import axios from "api";

export const getUnreadMessages = async (): Promise<ApiReturn> => {
  const config = {
    params: {},
  };

  try {
    const res = await axios.get(
      endpoints.messages.getUnreadMessageCount,
      config
    );
    if (res.data.status === "1") {
      return {
        response: res.data.details,
        errors: null,
      };
    } else {
      return {
        response: null,
        errors: res.data.errors,
      };
    }
  } catch (error) {
    if (error.response) {
      // Request made and server responded
      return error.response;
    } else if (error.request) {
      // The request was made but no response was received
      return error.request;
    } else {
      return error.message;
      // Something happened in setting up the request that triggered an Error
    }
  }
};

export const parseGetUnreadMessageCount = (details: any) => {
  if (!Array.isArray(details)) return 0;
  return details
    .filter(chat => chat.count)
    .reduce((sum, chat) => sum + chat.count, 0);
};
